






















import Vue from "vue";
import {
  DrillDownMenuItem,
  DrillDownMenuConfig,
  DrillDownMenuResponse,
  UseDrillDownMenu,
} from "./drilldown-menu.state";
import DDMenu from "./DDMenu.vue";
import { computed, ref, Ref } from "@vue/composition-api";
import { onTouchOutsideElms, remToPx } from "@/common/dom.functions";
import { emptyFn, isNotEmpty } from "@/fp";
import CustomDDMenu from "./CustomDDMenu.vue";
export default Vue.extend({
  components: { DDMenu, CustomDDMenu },
  setup() {
    const custom_cmp = ref(null);
    const open_to_side = ref("left");
    const is_custom = computed(() => isNotEmpty(custom_cmp.value));

    const { listenForDrillDownMenuMsgs } = UseDrillDownMenu();
    const menu: Ref<DrillDownMenuItem[]> = ref([]);
    const isShow = ref(false);
    const position = ref({
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    });

    let sessionResolver: (result: DrillDownMenuResponse) => void = () => {
      /*  */
    };

    // === click ===
    let clickUnSub = emptyFn();
    // === click end ===

    // === scroll ===
    const scrollListenr = (ev: Event) => {
      if (!ev.target || !(ev.target as HTMLElement).matches(".dd-menu-list")) {
        onCancel();
      }
    };
    let scrollUnSub = emptyFn();
    const scrollSub = () => {
      //@ts-ignore
      window.addEventListener("scroll", scrollListenr, true);
      //@ts-ignore
      return () => window.removeEventListener("scroll", scrollListenr, true);
    };

    // === scroll end ===

    listenForDrillDownMenuMsgs((menu_config: DrillDownMenuConfig) => {
      if (menu_config.cmp) {
        custom_cmp.value = menu_config.cmp;
      } else {
        custom_cmp.value = null;
      }
      menu.value = menu_config.menu;
      open_to_side.value = menu_config.side ? menu_config.side : "right";
      const { top, left, right, bottom } = (menu_config.event
        .currentTarget as HTMLElement).getBoundingClientRect();
      if (open_to_side.value == "right") {
        position.value = { top, left, right, bottom };
      } else {
        position.value = { top, left, right, bottom };
        position.value.left = position.value.left - remToPx(18);
      }
      isShow.value = true;
      scrollUnSub();
      clickUnSub();

      scrollUnSub = scrollSub();
      clickUnSub = onTouchOutsideElms(() => {
        onCancel();
      })(() => Array.from(document.querySelectorAll(".dd-menu")));

      return new Promise((resolve) => {
        sessionResolver = resolve;
      });
    });

    const onSubmit = (p: { item: DrillDownMenuItem }) => {
      sessionResolver({
        didUserSelectedAnAction: true,
        actionSelected: p.item.action as string,
      });
      close();
      scrollUnSub();
      clickUnSub();
    };

    const onCancel = () => {
      sessionResolver({ didUserSelectedAnAction: false });
      close();
      scrollUnSub();
      clickUnSub();
    };

    const close = () => {
      isShow.value = false;
    };

    return {
      is_custom,
      custom_cmp,
      onCancel,
      onSubmit,
      position,
      menu,
      isShow,
      open_to_side,
    };
  },
});
